<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="ownerProfileGuests" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="ownerProfileGuestId" selectionMode="single"
  [(selection)]="ownerProfileGuest" (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="showPagination" [rows]="25"
  [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end">
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
        }

        <!--add new-->
        <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
        (click)="onOpenFormAdd()">New Owner Profile Guest +</button>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    @if (recordTotal>0) {
      <tr>
        @for (col of columns; track col) {
          <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
            {{col.header}}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        }
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
    }
    @if (recordTotal<1) {
      <tr><td>No Refund Amounts.</td>
    </tr>
  }
  @if (showFilter) {
    <tr>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'ownerProfileGuestId', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'firstName', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'lastName', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'emailAddress', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'mobile', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'relationship', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'ownerProfileVO.ownerProfileId', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
  }
</ng-template>
<ng-template pTemplate="body" let-ownerProfileGuest>
  <tr [pSelectableRow]="ownerProfileGuest">
    <td>{{ownerProfileGuest.ownerProfileGuestId}} </td>
    <td>{{ownerProfileGuest.firstName}}</td>
    <td>{{ownerProfileGuest.lastName}}</td>
    <td>{{ownerProfileGuest.emailAddress}}</td>
    <td>{{ownerProfileGuest.mobile}}</td>
    <td>{{getRelationshipName(ownerProfileGuest)}}</td>
    <td>{{ownerProfileGuest.ownerProfileId}}</td>
    <td><span style="float:none">
      <a>
        <i class="pi pi-pencil" aria-hidden="true"
        style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(ownerProfileGuest)"></i>
      </a>
    </span>
  </td>
</tr>
</ng-template>
</p-table>